/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Owner_LabelInputs */



/**
* | output |
* | --- |
* | "Owner:" |
*
* @param {Explorer_Thumbnail_Owner_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_owner_label = /** @type {((inputs?: Explorer_Thumbnail_Owner_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Owner_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Proprietaire :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eigentümer:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Proprietario:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Владелец:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dueño:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有者：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("所有者：")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मालिक:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Proprietário:")
	return /** @type {LocalizedString} */ ("Owner:")
});